module.exports = __webpack_public_path__ + "static/media/sign up white.e0ce202c.svg";